export default{
    1 : '火烧赤壁',
    2 : '草船借箭',
    3 : '荆州之战',
    7 : '青梅煮酒',
    8 : '官渡之战',
    9 : '桃园结义',
    11 : '九伐中原',
    12 : '逐鹿中原',
    13 : '三分天下',
    16 : '怀旧服',
    17 : '铜雀台',
    18 : '凤仪亭',
    19 : '火凤燎原',
    20 : '卧龙出渊',
    21 : '长生殿',
    22 : '逍遥津',
    23 : '单刀赴会',
    100 : '测试大区1',
    101 : '测试大区2',
}


// WEBPACK FOOTER //
// ./src/components/areadic.js